import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Location, LocationWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateLocation(): UseMutationResult<
  AxiosResponse<Location>,
  AxiosError<ErrorMessage>,
  LocationWrite
> {
  const queryClient = useQueryClient();

  const updateLocation = useCallback((location: LocationWrite): Promise<AxiosResponse<Location>> => {
    return client.put(`locations/${location.locationId}/`, location);
  }, []);

  return useMutation(updateLocation, {
    onSuccess: () => {
      queryClient.invalidateQueries('locations');
    },
  });
}
